import { ListLoader } from "@/loaders";

export default {
  events: new ListLoader("/staff-events/preview/", {
    setter: "staffEventsStore/setEvents",
  }),
  eventKindOptions: new ListLoader("/event-kind-options/", {
    setter: "staffEventsStore/setEventKindOptions",
  }),
};
